// *********** useCarregaDados ***************************************
// *** app/agendexPrestador/hooks/useCarregaDados.jsx
// *** autor: W de Paula / MVinfo
// *** data: 09/09/24 | 13h40
// ***********************************************************


import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiaxios from '../../../Services/apiaxios.js';
import { apifetch } from '../../../Services/apifecth.js';
import handleApiError from '../../../Services/apiErrorHandler.js';
import { decrypt } from '../../../Services/cryptoUtils.js';
import { AutoLogout } from '../../../Services/autologout.js';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useCarregaDados = () => {
//     const tokenASW = localStorage.getItem("tokenasw"); // modificado pela linha abaixo 27/10/25w
const tokenASW = decrypt(localStorage.getItem('tokenasw'));

    const tokenlg = localStorage.getItem("tokenlg");

    useEffect(() => {
        if (!tokenASW || !tokenlg) {
            console.error('token adulterado. Acesso negado.');
            AutoLogout();
        }
    }, [tokenASW, tokenlg]);

    const [userId, setUserId] = useState();

    // verifica se existe o tokenapw (array com diversas variáveis de uso geral) está presente e se consegue descriptografar
    useEffect(() => {
        const encryptedUser = localStorage.getItem('tokenaaw');
        if (encryptedUser) {
            try {
                const decryptedUser = decrypt(encryptedUser);
                if (decryptedUser) {
                    setUserId(decryptedUser.id_usuario);
                }
            } catch (error) {
                console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            }
        }
    }, []);

    const [loading, setLoading] = useState(false);
    const MySwal = withReactContent(Swal);
    const [emailValidado, setEmailValidado] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const navigate = useNavigate();

    const carregaDados = async (idUsuario) => {
        setLoading(true);
        try {
            const response = await apiaxios.post('/usuario/perfilWeb', {
                id_usuario: idUsuario,
                tipo_app: 2
            },
            {
                params:{
                    id_usuario: idUsuario,
                    token: tokenASW
                }
            });

            if (response.status === 200) {
                const data = response.data;
                console.log('response.data: ', response.data);
                if (data.retorno === 'OK') {
                    setEmailValidado(data.ativa_conta);
                    await generateValidationCode(data.email, idUsuario);
                } else {
                    MySwal.fire('Erro', data.retorno, 'error');
                }
            } else {
                MySwal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const generateValidationCode = async (email, userId) => {
        if (!email) {
            setMensagem('Email não pode ficar em branco.');
            setTimeout(() => setMensagem(''), 7000);
            return;
        }

        setLoading(true);

        try {
            await apifetch(`/usuario/ContaExistenteWeb?email=${email}&tipoApp=2&id_usuario=${userId}&token=${tokenASW}`, {
                method: 'GET'
            });
    
            const validationCode = Math.floor(100000 + Math.random() * 900000).toString();

            const response = await apiaxios.post('/usuario/validaEmailWeb', {
                nome: '',
                email,
                codigo: validationCode,

            },
            {
                params:{
                    id_usuario: userId,
                    token: tokenASW
                }
            });

            navigate('/app/prestador/perfil/cv', { state: 
                { nome: '', email: email, id_usuario: userId, validationCode: validationCode, from: '/app/prestador/home/' } });
        } catch (error) {
            setMensagem(error.message.includes('CORS policy') ? 
                'Erro de CORS. Verifique as configurações do servidor.' :
                error.message === 'Failed to fetch' ?
                'Erro de conexão. Verifique sua conexão com a internet e tente novamente.' :
                error.message);
            setTimeout(() => setMensagem(''), 7000);
        } finally {
            setLoading(false);
        }
    };

    // const carregaTotalServicos = async (idUsuario, setQTServicos, setQTServicosAvulsos) => {
    //     setLoading(true);
    //     try {
    //         const response = await apiaxios.get('/servico/quantidadeWeb', {
    //             params: {id_empresa: idUsuario, id_usuario: idUsuario, token: tokenASW}
    //         });
    //         if (response.status === 200) {
    //             const data = response.data;
    //             if (data.length === 0 || (!data[0].QT_SERVICOS && !data[0].STATUS)) {
    //                 setQTServicos(0);
    //                 setQTServicosAvulsos(0);
    //             } else {
    //                 const qtServicos = data[0].QT_SERVICOS;
    //                 const status = data[0].STATUS;
    //                 setQTServicos(qtServicos);
    //                 setQTServicosAvulsos(qtServicos - status);
    //             }
    //         } else {
    //             Swal.fire('Erro', 'Falha ao carregar seus dados. Tente novamente mais tarde.', 'error');
    //         }
    //     } catch (error) {
    //         handleApiError(error);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    return { loading, setLoading, MySwal, carregaDados };
    // return { loading, setLoading, MySwal, carregaDados, carregaTotalServicos };
};
